export enum ProfileComponentCategory {
    About = 1,
    WorkHistory = 2,
    Education = 3,
    Qualifications = 4,
    References = 5,
    MyAyaContact = 6
}
